namespace $.$$ {

	$mol_style_attach( '$shm_ba_agent_message_text_style', `
		[shm_ba_agent_message_text_posts_invalid] {
			display: flex;
			flex-direction: column;
			gap: .5rem;
		}

		[shm_ba_agent_message_text_posts_error] {
			color: var(--mol_theme_control);
			font-weight: 600;
		}
	` )

}
